const programs = {
  gaushala: {
    hero: {
      badge: "ગૌ સેવા અને સંરક્ષણ",
      brand: "વૃંદાવન ગીર ગૌશાળા",
      title: "ગીર ગાયોની આદરપૂર્વક સેવા અને સુરક્ષા",
      subtitle:
        "દેશી ગીર ગાયો, વાછરડાં અને બળદો માટે આજીવન આશ્રય, તાજો લીલો ઘાસચારો, તબીબી સંભાળ અને સુરક્ષિત સ્થાન આપવા માટે સમર્પિત.",
      primaryCta: "ગૌશાળાને સહયોગ આપો",
      secondaryCta: "ગાયનું પ્રાયોજન કરો",
      imageAlt: "સ્વચ્છ પરિસરમાં ગીર ગાયો",
    },
    about: {
      eyebrow: "ગૌશાળા વિશે",
      heading: "જીવ દયા અને કરુણા સભર સંભાળ",
      tagline: "ગૌ સેવા એ માનવસેવાનું પવિત્ર રૂપ છે.",
      body: "અમારી વૃંદાવન ગીર ગૌશાળા ગીર ગાયોની સંભાળ, સુરક્ષા અને આજીવન આશ્રય માટે સમર્પિત છે. દરેક પશુને પૌષ્ટિક લીલો અને સૂકો ઘાસચારો, સતત તબીબી સંભાળ અને સ્વચ્છ વાતાવરણ મળે છે. અમે ગૌ સેવાને માનવસેવા અને જીવદયાનું ઉત્તમ ઉદાહરણ માનીએ છીએ.",
      capacityTitle: "વર્તમાન આશ્રય ક્ષમતા",
      capacityDesc: "હાલમાં 250+ ગીર ગાયો, વાછરડાં અને બળદોને આજીવન સંભાળ અને આશ્રય આપવામાં આવે છે.",
      expansionTitle: "ભાવિ વિસ્તરણ યોજના",
      expansionDesc: "અદ્યતન પશુ ચિકિત્સા ક્લિનિક, સોલાર શેડ અને મોટા ચરિયાણ વિસ્તાર સાથે 500+ ગાયો માટે ક્ષમતા વધારવાની યોજના.",
    },
    why: {
      eyebrow: "શા માટે સહયોગ આપવો",
      heading: "દરેક ગાય માટે સંપૂર્ણ કલ્યાણ",
      subtitle: "તમારો સહયોગ ગૌમાતા માટે ચોવીસે કલાક સંભાળ, પૌષ્ટિક આહાર અને સન્માન સુનિશ્ચિત કરે છે.",
      card1Title: "દૈનિક પૌષ્ટિક ઘાસચારો",
      card1Desc: "દરરોજ તાજો લીલો ઘાસચારો, સૂકો ચારો અને ઓર્ગેનિક પોષક મિશ્રણ.",
      card2Title: "તબીબી સંભાળ",
      card2Desc: "સમર્પિત પશુ ચિકિત્સક ટીમ, નિયમિત આરોગ્ય તપાસ અને કટોકટી સંભાળ.",
      card3Title: "સુરક્ષિત આશ્રયસ્થાન",
      card3Desc: "ઋતુગત હવામાનથી રક્ષણ અને આરામ માટે વિશાળ, હવાઉજસવાળા શેડ.",
      card4Title: "સ્વચ્છ વાતાવરણ",
      card4Desc: "આરોગ્યપ્રદ પરિસર, પીવાના સ્વચ્છ પાણીની ટાંકીઓ અને રોજિંદી સફાઈ.",
      card5Title: "આજીવન રક્ષણ",
      card5Desc: "વૃદ્ધ, દૂધ ન આપતી, ઇજાગ્રસ્ત અને રક્ષાયેલી ગાયો માટે આજીવન આશ્રય.",
      card6Title: "ગૌ કલ્યાણ",
      card6Desc: "કરુણા, આદર અને પરંપરાગત મૂલ્યોમાં મૂળ ધરાવતી શુદ્ધ ગૌ સેવા.",
    },
    sponsorships: {
      eyebrow: "પ્રાયોજન કાર્યક્રમો",
      heading: "તમારી પ્રાયોજન યોજના પસંદ કરો",
      subtitle: "ઘાસચારો, તબીબી સંભાળ અને ગૌશાળા વિકાસ માટે પારદર્શક સહયોગ.",
      sponsorNow: "પ્રાયોજન કરો",
      popularBadge: "સૌથી લોકપ્રિય",
      decadeBadge: "વિશેષ સેવા",
    },
    stats: {
      eyebrow: "અમારો પ્રભાવ",
      heading: "ગૌ સેવાના મહત્વપૂર્ણ આંકડા",
      cowsSheltered: "આશ્રય મેળવેલ ગાયો",
      dailyMeals: "દૈનિક પૂરો પાડવામાં આવતો આહાર",
      medicalCare: "તબીબી સંભાળ અને આરોગ્ય",
      yearsOfService: "સમર્પિત સેવાના વર્ષો",
    },
    gallery: {
      eyebrow: "ગૌશાળા ગેલેરી",
      heading: "સંભાળ અને આશ્રયની ઝલક",
      item1Title: "વિશ્રામ કરતી ગીર ગાયો",
      item1Desc: "સ્વચ્છ ખુલ્લા શેડમાં આરામ કરતી ગાયો.",
      item2Title: "સવારનો ઘાસચારો",
      item2Desc: "તાજા લીલા ઘાસચારાનું વિતરણ.",
      item3Title: "સ્વચ્છ ગૌશાળા શેડ",
      item3Desc: "વિશાળ અને સુવિધાસભર પરિસર.",
      item4Title: "સમર્પિત સ્વયંસેવકો",
      item4Desc: "પ્રેમપૂર્વક ગૌસેવા કરતા ભક્તો.",
      item5Title: "તબીબી તપાસ",
      item5Desc: "નિયમિત આરોગ્ય અને રસીકરણ તપાસ.",
      item6Title: "રમતાં વાછરડાં",
      item6Desc: "ગૌશાળાના મેદાનમાં આનંદિત વાછરડાં.",
    },
    visit: {
      eyebrow: "ગૌ સેવાનો અનુભવ કરો",
      heading: "ગૌશાળાની મુલાકાત લો",
      subtitle: "ગીર ગાયોની હાજરીમાં શાંતિપૂર્ણ ક્ષણો વિતાવો. ગૌસેવા, ઘાસચારો આપવાનો અને સવાર-સાંજની ગૌ આરતીનો આનંદ અનુભવો.",
      locationTitle: "સ્થળ",
      locationDesc: "જીવનધારા સંસ્થાન કેમ્પસ, વૃંદાવન ગીર ગૌશાળા, ગુજરાત",
      hoursTitle: "મુલાકાતનો સમય",
      hoursDesc: "દરરોજ મુલાકાતીઓ માટે ખુલ્લું: સવારે 7:00 – 11:30 અને સાંજે 4:00 – 6:30",
      planVisit: "મુલાકાતનું આયોજન કરો",
      contactUs: "ગૌશાળા ટીમનો સંપર્ક કરો",
    },
    faq: {
      eyebrow: "પ્રશ્નો છે?",
      heading: "વારંવાર પૂછાતા પ્રશ્નો",
      q1: "હું ગાયનું પ્રાયોજન કેવી રીતે કરી શકું?",
      a1: "ઉપર આપેલી પ્રાયોજન યોજનાઓમાંથી પસંદ કરો અને 'પ્રાયોજન કરો' પર ક્લિક કરી ઓનલાઇન સુરક્ષિત ચૂકવણી પૂર્ણ કરો.",
      q2: "મારા દાનનો ઉપયોગ કેવી રીતે થાય છે?",
      a2: "તમારા દાનની 100% રકમ લીલો-સૂકો ઘાસચારો, તબીબી દવાઓ અને શેડની જાળવણી માટે વપરાય છે.",
      q3: "શું હું ગૌશાળાની મુલાકાત લઈ શકું?",
      a3: "હા! મુલાકાતીઓ અને પરિવારોનું મુલાકાતના કલાકો દરમિયાન ગૌસેવા અને ગૌ આરતી માટે હાર્દિક સ્વાગત છે.",
      q4: "શું દાનની પહોંચ મળે છે?",
      a4: "હા, સફળ ચૂકવણી પછી 80G કર રાહત સાથેની ડિજિટલ પહોંચ તરત જ પ્રાપ્ત થાય છે.",
      q5: "શું હું બહુવિધ વર્ષો કે ખાસ પ્રસંગો માટે પ્રાયોજન કરી શકું?",
      a5: "હા, 2, 5 અને 10 વર્ષના કાર્યક્રમો ઉપલબ્ધ છે. આપ જન્મદિવસ કે પુણ્યતિથિ જેવા પ્રસંગોએ પણ પ્રાયોજન કરી શકો છો.",
      q6: "ગૌશાળા વિકાસ ફંડ શું છે?",
      a6: "વિકાસ ફંડ (₹6,000) શેડ નિર્માણ, પાણીની ટાંકીઓ અને પશુ દવાખાનાની સુવિધાઓના વિસ્તરણમાં સીધો ઉપયોગ થાય છે.",
    },
    cta: {
      heading: "ગૌ સેવાનો ભાગ બનો",
      subtitle: "ગીર ગાયોની સંભાળ, પોષણ અને આજીવન રક્ષણ માટે આપનું યોગદાન આપો.",
      sponsorNow: "પ્રાયોજન કરો",
    },
  },
  gruhUdhyog: {
    hero: {
      badge: "100% શુદ્ધ અને ગૃહનિર્મિત",
      brand: "જીવનધારા ગૃહ ઉદ્યોગ",
      title: "પ્રેમ અને પરંપરાથી બનેલી વાનગીઓ અને હસ્તકળા",
      subtitle: "વડીલો અને મહિલા સ્વસહાય જૂથો દ્વારા તૈયાર કરાયેલ પરંપરાગત નાસ્તા, અથાણાં, મસાલા, મીઠાઈઓ અને સુશોભન વસ્તુઓ. 100% આવક વડીલોની સેવા માટે.",
      primaryCta: "ઉત્પાદનો જુઓ",
      secondaryCta: "અમારું લક્ષ્ય",
    },
    categories: {
      all: "બધા ઉત્પાદનો",
      snacks: "ગૃહનિર્મિત નાસ્તો",
      pickles: "શુદ્ધ અથાણાં",
      spices: "દળેલા મસાલા",
      sweets: "પરંપરાગત મીઠાઈઓ",
      handicrafts: "હસ્તકળા શિલ્પ",
    },
    catalog: {
      eyebrow: "અમારા ઉત્પાદનો",
      heading: "અમારું ગૃહનિર્મિત કલેક્શન જુઓ",
      subtitle: "સ્વચ્છ વાતાવરણમાં શુદ્ધ સામગ્રી અને પરંપરાગત રેસિપી સાથે નિર્મિત.",
      note: "શું તમે તહેવારો અથવા બલ્ક ઓર્ડર કરવા માંગો છો? ",
      contactUs: "અમારી ટીમનો સંપર્ક કરો",
    },
    featured: {
      eyebrow: "લોકપ્રિય વાનગીઓ",
      heading: "સૌથી વધુ પસંદ કરાયેલ વાનગીઓ",
      subtitle: "ગુજરાત અને ભારતના હજારો પરિવારો દ્વારા પસંદ કરાયેલ.",
    },
    artisans: {
      eyebrow: "સ્વાવલંબન અને ગૌરવ",
      heading: "અમારા વડીલ કલાકારોની કહાની",
      subtitle: "દરેક વાનગી અને વસ્તુ ગૌરવ અને પ્રેમનું પ્રતીક છે.",
      quote: "આ પરંપરાગત વાનગીઓ બનાવવાથી અમને રોજ આનંદ, ભાઈચારો અને ગૌરવની અનુભૂતિ થાય છે.",
      a1Name: "મંજુલા બેન શાહ",
      a1Craft: "ખાખરા અને ફરસાણ નિષ્ણાત",
      a1Years: "12 વર્ષથી સેવા",
      a2Name: "સરોજ બેન મહેતા",
      a2Craft: "અથાણાં અને છૂંદા સ્પેશિયાલિસ્ટ",
      a2Years: "9 વર્ષથી સેવા",
      a3Name: "લીલાવતી બેન જોશી",
      a3Craft: "મસાલા અને મીઠાઈ નિષ્ણાત",
      a3Years: "15 વર્ષથી સેવા",
    },
    by: "દ્વારા",
    cta: {
      heading: "વડીલોના ગૌરવને સપોર્ટ કરો અને શુદ્ધ સ્વાદ માણો",
      body: "આજે જ ઓનલાઇન ઓર્ડર કરો અથવા તહેવાર માટે બલ્ક ઓર્ડર બુક કરો. 100% રકમ વડીલોના રહેઠાણ અને સારવારમાં વપરાય છે.",
      support: "સપોર્ટ કરો",
      order: "બલ્ક / તહેવાર ઓર્ડર કરો",
    },
  },
  tiffinSeva: {
    hero: {
      eyebrow: "જીવનધારા વૃદ્ધાશ્રમ પહેલ",
      title: "વરિષ્ઠ નાગરિક અને સામુદાયિક ટિફિન સેવા",
      subtitle:
        "ઘરે રહેતા વરિષ્ઠ નાગરિકો (મંજૂરી પર ૬૦+ મફત) અને જરૂરિયાતમંદ પરિવારો (<૬૦, ₹૧૦૦ ફી સાથે) ના ઘર આંગણે ગરમ, પૌષ્ટિક સાત્ત્વિક ભોજન પહોંચાડવું.",
    },
    about: {
      eyebrow: "પહેલ વિશે",
      title: "ટિફિન સેવા વિશે",
      tagline:
        "નિઃસ્વાર્થ રસોઈ, ભક્તિ અને કરુણા દ્વારા મન, શરીર અને આત્માનું પોષણ.",
      body: "ટિફિન સેવા વરિષ્ઠ નાગરિકો, દિવ્યાંગ વ્યક્તિઓ અને જરૂરિયાતમંદ પરિવારોને શુદ્ધ, આરોગ્યપ્રદ અને સાત્ત્વિક ભોજન પૂરું પાડે છે. અન્નપૂર્ણા ભોજનશાળાના આધ્યાત્મિક માર્ગદર્શન હેઠળ તૈયાર કરાયેલા દરેક ટિફિનમાં ગરમ રોટલી, દાળ, ભાત, ઋતુગત શાક અને છાશનો સમાવેશ થાય છે.",
      applyBtn: "ટિફિન સેવા માટે અરજી કરો",
      donateBtn: "સહયોગ અને દાન",
    },
    specialization: {
      badge: "અમારી મુખ્ય શક્તિઓ",
      title: "ટિફિન સેવા વિશેષતાઓ",
      desc: "રોજિંદી સમયસર ડિલિવરી, પવિત્ર રાંધણ ધોરણો અને ઉત્કૃષ્ટ સ્વચ્છતા સાથે તૈયાર.",
      items: {
        jainFood: {
          title: "૧૦૦% જૈન ભોજન",
          tagline: "શુદ્ધ સાત્ત્વિક અને પવિત્ર",
          desc: "જૈન આહારના સિદ્ધાંતોનું પાલન કરીને શુદ્ધ, પવિત્ર રસોડામાં ડુંગળી, લસણ અથવા કંદમૂળ વગર સખત રીતે તૈયાર કરવામાં આવે છે.",
          badge: "૧૦૦% જૈન",
        },
        delivery: {
          title: "સમયસર ડિલિવરી",
          tagline: "સમયસર ઘર આંગણે સેવા",
          desc: "બપોરના ભોજન માટે ૧૨:૩૦ પહેલા અને ચૌવિહાર રાત્રિ ભોજન માટે સૂર્યાસ્ત પહેલા દૈનિક ડિલિવરી, જેથી ભોજન ગરમ અને તાજું માણી શકાય.",
          badge: "દૈનિક સમયસર",
        },
        regular: {
          title: "નિયમિત દૈનિક ટિફિન",
          tagline: "૩૬૫ દિવસ અવિરત",
          desc: "વર્ષ દરમિયાન શૂન્ય વિક્ષેપ સાથે વિશ્વસનીય દૈનિક સેવા, જેથી વરિષ્ઠ નાગરિકો અને આશ્રિત પરિવારોને ક્યારેય ગરમ ભોજનની ચિંતા ન થાય.",
          badge: "૩૬૫ દિવસ સક્રિય",
        },
        authentic: {
          title: "શ્રેષ્ઠ અને અસલી જૈન સ્વાદ",
          tagline: "પૌષ્ટિક અને પરંપરાગત",
          desc: "પ્રેમ અને કાળજીપૂર્વક બનેલી ગરમ ફુલેલી રોટલી, સુગંધિત ગુજરાતી દાળ, બાસમતી ભાત, ઋતુગત શાક અને તાજી છાશ.",
          badge: "અસલી સ્વાદ",
        },
      },
    },
    registration: {
      senior: {
        badge: "૬૦ વર્ષથી વધુ",
        tag: "મફત / ટ્રસ્ટ સહાયિત",
        title: "વરિષ્ઠ નાગરિક નોંધણી",
        desc: "નિયમિત સાત્ત્વિક ભોજનની જરૂરિયાતવાળા વરિષ્ઠ નાગરિકો અને દંપતીઓ (૬૦+ વર્ષ) માટે વિશેષ સમર્પિત.",
        bullet1: "શૂન્ય નોંધણી ફી (ટ્રસ્ટ દ્વારા સંપૂર્ણ સહાયિત)",
        bullet2: "એડમિન વેરિફિકેશન અને મંજૂરીને આધીન",
        bullet3: "ગરમ સાત્ત્વિક બપોરનું અને રાત્રિનું ભોજન ઘર આંગણે",
        btn: "અરજી કરો (૬૦ વર્ષથી વધુ)",
      },
      general: {
        badge: "૬૦ વર્ષથી ઓછી",
        tag: "ફી: ₹૧૦૦",
        title: "સામાન્ય / જરૂરિયાતમંદ નોંધણી",
        desc: "૬૦ વર્ષથી ઓછી ઉંમરના વ્યક્તિઓ, દિવ્યાંગો અથવા ભોજન સહાયની જરૂરિયાતવાળા પરિવારો માટે.",
        bullet1: "માત્ર ₹૧૦૦ ની નજીવી નોંધણી ફી",
        bullet2: "દસ્તાવેજ ચકાસણી સાથે ઝડપી પ્રક્રિયા",
        bullet3: "શુદ્ધ શાકાહારી સાત્ત્વિક ભોજન દરરોજ વિતરિત",
        btn: "અરજી કરો (૬૦ વર્ષથી ઓછી - ₹૧૦૦ ફી)",
      },
    },
    eligibility: {
      badge: "કોણ લાભ મેળવી શકે?",
      title: "ટિફિન સેવા માટે યોગ્યતા",
      cards: {
        senior: {
          title: "વરિષ્ઠ નાગરિકો (૬૦+ ઉંમર)",
          desc: "એકલા રહેતા વડીલો, રસોઈ કરવામાં અસમર્થ, અથવા દૈનિક સાત્ત્વિક આહારની જરૂરિયાત વાળા. એડમિન ચકાસણી પછી ટ્રસ્ટના સહયોગથી સંપૂર્ણ સબસિડીયુક્ત.",
          tag: "મફત / ટ્રસ્ટ પ્રાયોજિત",
        },
        general: {
          title: "સામાન્ય નોંધણી (<૬૦ વર્ષ)",
          desc: "ઘર આંગણે સાત્ત્વિક ભોજન સહાયની જરૂરિયાત વાળા જરૂરિયાતમંદ વ્યક્તિઓ, પરિવારો અથવા દિવ્યાંગો.",
          tag: "ફી: ₹૧૦૦",
        },
        divyang: {
          title: "દિવ્યાંગ (વિકલાંગ વ્યક્તિઓ)",
          desc: "શારીરિક રીતે પડકારરૂપ વ્યક્તિઓ કે જેમને દરરોજ ગરમ પૌષ્ટિક ભોજનની ઘરે પહોંચાડવાની જરૂર હોય.",
          tag: "ઘરે ડિલિવરી",
        },
      },
    },
    howItWorks: {
      badge: "સરળ ૪-પગલાંની પ્રક્રિયા",
      title: "ટિફિન સેવા કેવી રીતે કામ કરે છે",
      steps: {
        step1: {
          title: "કેટેગરી પસંદ કરો",
          desc: "૬૦ વર્ષથી વધુ (વરિષ્ઠ સેવા) અથવા ૬૦ વર્ષથી નીચે (₹૧૦૦ ફી) પસંદ કરો.",
        },
        step2: {
          title: "વિગતો ભરો",
          desc: "અરજદાર, પરિવારની વિગતો, નાણાકીય માહિતી અને ઓળખ કાર્ડ અપલોડ કરો.",
        },
        step3: {
          title: "ચકાસણી અને મંજૂરી",
          desc: "અમારા કો-ઓર્ડિનેટર અરજીની સમીક્ષા કરે છે અને ડિલિવરી ઝોનની ચકાસણી કરે છે.",
        },
        step4: {
          title: "ટિફિન ડિલિવરી શરૂ",
          desc: "તાજું ગરમ સાત્ત્વિક ભોજન દરરોજ સીધું તમારા ઘર આંગણે પહોંચાડવામાં આવે છે.",
        },
      },
    },
    modal: {
      title: "ટિફિન સેવા માટે અરજી કરો",
      subtitle: "પ્રેમ અને ભક્તિ સાથે તૈયાર કરાયેલ તાજું, આરોગ્યપ્રદ અને પૌષ્ટિક સાત્ત્વિક ભોજન ઘર આંગણે.",
      badgeSenior: "૬૦ વર્ષથી વધુ (વરિષ્ઠ સેવા)",
      badgeGeneral: "૬૦ વર્ષથી ઓછી (₹૧૦૦ ફી)",
      categoryStep: {
        heading: "નોંધણી કેટેગરી પસંદ કરો",
        desc: "ટિફિન સેવા નોંધણી ચાલુ રાખવા માટે લાભાર્થીની ઉંમર જૂથ પસંદ કરો.",
        seniorBadge: "ટ્રસ્ટ સહાયિત",
        seniorTitle: "૬૦ વર્ષથી વધુ (વરિષ્ઠ નાગરિક)",
        seniorDesc: "એકલા રહેતા અથવા રસોઈ કરવામાં અસમર્થ વરિષ્ઠ નાગરિકો અને વડીલ દંપતી માટે વિશેષ સમર્પિત.",
        seniorFee: "મફત / સબસિડીયુક્ત",
        seniorNote: "એડમિન મંજૂરીને આધીન",
        generalBadge: "ફી: ₹૧૦૦",
        generalTitle: "૬૦ વર્ષથી ઓછી (સામાન્ય / જરૂરિયાતમંદ)",
        generalDesc: "૬૦ વર્ષથી ઓછી ઉંમરના વ્યક્તિઓ, દિવ્યાંગો અથવા આર્થિક રીતે નબળા પરિવારો માટે.",
        generalFee: "ફી: ₹૧૦૦",
        generalNote: "તત્કાળ પ્રક્રિયા",
        qualityNote: "તમામ ભોજન સ્વચ્છ સાત્ત્વિક રસોડાની સુવિધાઓમાં કડક ગુણવત્તા અને સ્વચ્છતા ધોરણો હેઠળ તૈયાર કરવામાં આવે છે.",
      },
      successStep: {
        seniorTitle: "અરજી સબમિટ! એડમિન મંજૂરીની રાહ જોઈ રહ્યા છીએ.",
        seniorDesc: "અમારા ટિફિન સેવા કો-ઓર્ડિનેટર અરજીની વિગતો, રહેઠાણ અને ઓળખ દસ્તાવેજો ચકાસશે. મંજૂરી થતાં જ અમે તમારો સંપર્ક કરીશું:",
        seniorDescEnd: "",
        generalFeeLabel: "નોંધણી ફી: ₹૧૦૦",
        generalTitle: "ટિફિન સેવા અરજી સફળ!",
        generalDesc: "ટિફિન સેવા (૬૦ વર્ષથી ઓછી) માટે તમારી નોંધણી ₹૧૦૦ ની ફી સાથે નોંધાઈ ગઈ છે.",
        generalDescEnd: " ડિલિવરી સૂચિ મુજબ શરૂ થશે.",
        summaryTitle: "અરજી સારાંશ",
        summaryAbove60: "૬૦ વર્ષથી વધુ",
        summaryBelow60: "૬૦ વર્ષથી ઓછી",
        labelApplicant: "અરજદાર",
        labelMobile: "મોબાઇલ",
        labelTiffinPeriod: "ટિફિન સમયગાળો",
        labelFeeStatus: "ફી સ્થિતિ",
        feeFree: "મફત (ટ્રસ્ટ પ્રાયોજિત)",
        feePaid: "₹૧૦૦ (નોંધણી ફી)",
        immediate: "તત્કાળ",
        to: "થી",
        close: "બંધ કરો",
        thankYou: "ધન્યવાદ,",
      },
      formStep: {
        switchCategory: "કેટેગરી બદલો",
        categoryLabel: "કેટેગરી:",
        seniorCategoryText: "૬૦ વર્ષથી વધુ (વરિષ્ઠ નાગરિક)",
        generalCategoryText: "૬૦ વર્ષથી ઓછી",
        registrationFeesBadge: "નોંધણી ફી: ₹૧૦૦",
        trustSponsoredBadge: "ટ્રસ્ટ સહાયિત (એડમિન મંજૂરી)",
        section1Title: "અરજદારની વિગતો",
        tiffinStartDate: "ટિફિન શરૂ થવાની તારીખ",
        tiffinEndDate: "ટિફિન સમાપ્ત તારીખ (વૈકલ્પિક)",
        endDatePlaceholder: "ચાલુ ટિફિન માટે ખાલી છોડો",
        name: "નામ",
        namePlaceholder: "લાભાર્થી / અરજદારનું પૂરું નામ દાખલ કરો",
        address: "સરનામું",
        addressPlaceholder: "ઘર / ફ્લેટ નં., સોસાયટી / શેરી, લેન્ડમાર્ક, શહેર અને પિનકોડ",
        age: "ઉંમર",
        agePlaceholderSenior: "દા.ત. ૬૮ (૬૦+ ફરજિયાત)",
        agePlaceholderGeneral: "દા.ત. ૪૨",
        gender: "લિંગ",
        male: "પુરૂષ",
        female: "સ્ત્રી",
        other: "અન્ય",
        dateOfBirth: "જન્મ તારીખ",
        mobileNo: "મોબાઇલ નં.",
        section2Title: "કૌટુંબિક વિગતો",
        section2Desc: "પરિવારના સભ્યો અને ઘરની વિગતો",
        addFamilyMember: "સભ્ય ઉમેરો",
        colName: "નામ",
        colAge: "ઉંમર",
        colRelationship: "સંબંધ",
        colOccupation: "વ્યવસાય",
        colMobile: "મોબાઇલ",
        colAction: "ક્રિયા",
        section3Title: "નાણાકીય અને અન્ય વિગતો",
        monthlyIncome: "પરિવારની માસિક આવક",
        monthlyIncomePlaceholder: "દા.ત. ₹10,000 / મહિનો અથવા શૂન્ય",
        tiffinRecipient: "ટિફિન લાભાર્થી",
        tiffinRecipientPlaceholder: "દા.ત. સ્વ, વૃદ્ધ માતા-પિતા, દિવ્યાંગ",
        referenceName: "સંદર્ભ આપનારનું નામ",
        referenceNamePlaceholder: "ડૉક્ટર / પડોશી / ટ્રસ્ટ ટ્રસ્ટી / સામાજિક કાર્યકર",
        referenceMobile: "સંદર્ભ આપનારનો મોબાઇલ નં.",
        referenceAddress: "સંદર્ભ આપનારનું સરનામું",
        referenceAddressPlaceholder: "સરનામું / વિસ્તાર",
        referenceOccupation: "સંદર્ભ આપનારનો વ્યવસાય",
        referenceOccupationPlaceholder: "દા.ત. ડૉક્ટર, વેપારી, સામાજિક કાર્યકર",
        tiffinArrangement: "ટિફિન વ્યવસ્થાની વિગત",
        tiffinArrangementPlaceholder: "દા.ત. ફક્ત લંચ, ફક્ત ડિનર, બંને ભોજન, ડિલિવરી સમય...",
        reasonForTiffin: "ટિફિન આપવાનું કારણ",
        reasonPlaceholder: "પરિસ્થિતિ સ્પષ્ટ કરો: દા.ત. એકલા રહેતા વૃદ્ધ, રસોઈ અસમર્થ, આર્થિક મુશ્કેલી...",
        section4Title: "ઓળખ પ્રમાણ",
        selectIdDocs: "ઉપલબ્ધ ઓળખ દસ્તાવેજ પસંદ કરો:",
        aadhaar: "આધાર કાર્ડ",
        rationCard: "રેશન કાર્ડ",
        voterId: "ચૂંટણી કાર્ડ / મતદાર ઓળખ",
        uploadLabel: "ઓળખ વિકલ્પ અપલોડ (PDF / ફોટો)",
        uploadPrompt: "આધાર / રેશન / મતદાર ઓળખ અપલોડ કરો",
        changeDoc: "અલગ દસ્તાવેજ પસંદ કરો",
        back: "પાછળ",
        cancel: "રદ કરો",
        submitting: "સબમિટ થઈ રહ્યું છે...",
        submitSenior: "એડમિન મંજૂરી માટે સબમિટ કરો",
        submitGeneral: "અરજી સબમિટ (₹૧૦૦ ચૂકવો)",
      },
      errors: {
        nameRequired: "અરજદારનું નામ દાખલ કરો",
        mobileRequired: "મોબાઇલ નંબર દાખલ કરો",
        addressRequired: "સરનામું દાખલ કરો",
        submitError: "અરજી સબમિટ કરવામાં ભૂલ. ફરી પ્રયાસ કરો.",
        genericError: "કંઈ ખોટું ગયું. ફરી પ્રયાસ કરો.",
      },
      toastSenior: "તમારી અરજી સબમિટ થઈ. એડમિન મંજૂરીની રાહ જુઓ.",
      toastGeneral: "ટિફિન સેવા અરજી સફળ. ફી: ₹૧૦૦.",
    },
    toast: {
      error: "સબમિટ કરી શકાયું નહીં",
      success: "વિનંતી સબમિટ થઈ. અમારી ટીમ જલ્દી જ તમારો સંપર્ક કરશે.",
    },
  },
  bhojanshala: {
    hero: {
      badge: "સાત્ત્વિક આહાર • પવિત્ર સેવા",
      brand: "ભોજનશાળા",
      title: "અન્નદાન સેવાનું સૌથી ઉમદા રૂપ છે",
      subtitle:
        "ભક્તો, યાત્રીઓ, વડીલ નાગરિકો અને મુલાકાતીઓ માટે શુદ્ધ અને પૌષ્ટિક ભોજન તથા આવશ્યક ભોજન સેવાઓનું પ્રાયોજન કરીને ભોજનશાળાને સહયોગ આપો.",
      primaryCta: "ભોજન પ્રાયોજન કરો",
      secondaryCta: "પ્રાયોજન વિકલ્પો જુઓ",
      imageAlt: "ભોજનશાળામાં પીરસાયેલું સાત્ત્વિક ભોજન થાળી",
    },
    about: {
      eyebrow: "પહેલ વિશે",
      heading: "ભોજનશાળા વિશે",
      tagline:
        "નિઃસ્વાર્થ રસોઈ અને ભક્તિ દ્વારા મન, શરીર અને આત્માનું પોષણ.",
      body: "ભોજનશાળા યાત્રીઓ, ભક્તો, વડીલ નાગરિકો અને મુલાકાતીઓને શુદ્ધ, સ્વચ્છ અને સાત્ત્વિક ભોજન પૂરું પાડે છે. દાતાઓ નવકારશી, બપોરનું ભોજન, રાત્રિ ભોજન, મીઠાઈ, ફરસાણ, ટિફિન સેવા, ફળ અને દૂધ સહિત વિવિધ ભોજન પ્રાયોજનો દ્વારા સહયોગ કરી શકે છે.",
    },
    schemes: {
      eyebrow: "લાંબા ગાળાના પ્રાયોજનો",
      heading: "કાયમી ભોજન પ્રાયોજન",
      subtitle: "૧૦ વર્ષ માટે કાયમી ભોજન તિથિ પ્રાયોજન વિકલ્પો.",
      sponsorNow: "હવે પ્રાયોજન કરો",
      lifetime: "આજીવન",
      empty: "પ્રાયોજન યોજનાઓ ટૂંક સમયમાં અહીં દેખાશે.",
    },
    packages: {
      eyebrow: "વ્યક્તિગત અને તહેવાર સેવાઓ",
      heading: "અન્ય ભોજન પ્રાયોજન વિકલ્પો",
      subtitle:
        "ભોજનશાળા માટે સંપૂર્ણ ભોજન દિવસ, તહેવાર ભોજન અથવા રજા સેવાનું પ્રાયોજન કરો.",
      sponsorship: "પ્રાયોજન",
      availableToday: "આજે ઉપલબ્ધ",
      nextAvailable: "આગળ ઉપલબ્ધ: કાલે",
      sponsorNow: "હવે પ્રાયોજન કરો",
      empty: "ભોજન પેકેજો ટૂંક સમયમાં અહીં દેખાશે.",
    },
    special: {
      eyebrow: "આહાર અને સમુદાય સમૃદ્ધિ",
      heading: "વિશેષ સેવા પ્રાયોજનો",
      subtitle:
        "વિશિષ્ટ વસ્તુઓ, આરોગ્ય માટે ફળ, સાંજનું ગરમ દૂધ અથવા વડીલો માટે ટિફિન પાર્સલ પૂરા પાડો.",
      availableToday: "આજે ઉપલબ્ધ",
      nextAvailable: "આગળ ઉપલબ્ધ: કાલે",
      sponsorNow: "હવે પ્રાયોજન કરો",
      empty: "વિશેષ સેવાઓ ટૂંક સમયમાં અહીં દેખાશે.",
    },
    note: {
      title: "મહત્વપૂર્ણ નોંધ",
      body: "વિશેષ મીઠાઈની વ્યવસ્થા માટેનું પ્રાયોજન રકમ અલગથી વસૂલવામાં આવશે.",
    },
    supporting: {
      badge: "સહાયક દાતા • સતત મદદ",
      heading: "ભોજનશાળા સહાયક દાતા બનો",
      body: "ભોજનશાળાની નિયમિત સેવાઓ, જાળવણી અને દૈનિક કામગીરી માટે સહાયક દાતા બનીને યોગદાન આપો.",
      contribution: "યોગદાન",
      amount: "₹9,000",
      amountLabel: "સતત યોગદાન",
      cta: "સહાયક દાતા બનો",
    },
    loading: "ભોજનશાળા વિકલ્પો લોડ થઈ રહ્યા છે…",
  },
};

export default programs;
